module.exports = __webpack_public_path__ + "779d5c48c64bc02fcc75f2248ee5e195.gif";


//////////////////
// WEBPACK FOOTER
// ./fe/web-default/src/js/components/CookiesPolicy/img/motive.gif
// module id = 423
// module chunks = 3